import './BreadcrumbMenu.scss'
import { Link } from "react-router-dom";
import { Fragment, ReactNode } from "react";
import { useFetchSeason } from "~hooks/apiHooks/useFetchSeason";
import type { SeasonResponse } from "~types/season.ts";
import { useFetchOrganization } from "~entities/api";
import { useGetLocationParams } from "~hooks/useGetLocationParams.ts";
import { useIntl } from "react-intl";

export const BreadcrumbMenu = () => {
  const { organizationId, seasonId, customerId, sport } = useGetLocationParams();
  const { formatMessage } = useIntl();

  const items: Array<ReactNode> = [
    <Link style={{fontWeight: "bold"}} to={`/`} replace>
      {formatMessage({id: 'menu.select.customer'})}
    </Link>
  ]

  const { data: organizationData } = useFetchOrganization();

  if(customerId){
    items.push(
      <Link to={`/${customerId}/select/organization`} replace>
        {formatMessage({id: 'organizations'})}
      </Link>
    )
  }

  if(organizationData){
    items.push(
      <Link to={`/${customerId}/admin/${sport}/${organizationId}/dashboard/`}>
        <div>{organizationData.nameLocal || organizationId}</div>
      </Link>
    )
  }

  const { data: season } = useFetchSeason(seasonId, undefined, (seasonData: SeasonResponse) => {
    return { ...seasonData.data[0] }
  });

  if(season){
    items.push(
      <Link to={`${customerId}/admin/${sport}/${organizationId}/seasons/${seasonId}/fixtures`}>
        <div>{season.nameLocal || seasonId}</div>
      </Link>
    )
  }


  return (
    <div className="breadcrumb-menu">
      {items.map((label, idx) => (
        <Fragment key={`${label}-${idx}`}>
          <div className="menu-label">{label}</div>
          {idx < items.length - 1 && <i className="fas fa-angle-right menu-icon" aria-hidden="true"/>}
        </Fragment>
      ))}
    </div>
  )
}